import { theme } from 'antd';
import { BLUE, GREEN, ORANGE, RED } from 'pos-client/utils/colours.ts';

export const useJobStatusTextColor = (status: string) => {
  const { token } = theme.useToken();

  switch (status) {
    case 'to do':
      return BLUE.color;
    case 'in progress':
    case 'awaiting caf':
      return ORANGE.color;
    case 'conflict':
    case 'in progress - overrunning':
      return RED.color;
    case 'completed':
    case 'complete':
      return GREEN.color;
    case 'bypassed':
    case 'sub contracted':
      return token.colorWhite;
    case 'Authorized':
    case 'Unauthorized':
      return token.colorTextSecondary;
    default:
      return token.colorTextSecondary;
  }
};
// if these statuses are to come from static config then the styling data needs to come from there as well
